import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

export default function FlightTable() {
	const { bookinghistoryagent } = useSelector((state) => state.user);
	const history = useHistory();

	const dispatch = useDispatch();
	const columns = [
		{ field: 'orderId', headerName: 'OrderId', width: 150 },
		{ field: 'origin', headerName: 'Origin', width: 150 },
		{ field: 'destination', headerName: 'Destination', width: 150 },
		{ field: 'flightType', headerName: 'FlightType', width: 150 },
		{ field: 'journeyType', headerName: 'Journey Type', width: 150 },
		{ field: 'dob', headerName: 'Date of Booking', width: 150 },
		{ field: 'travelDate', headerName: 'Travel Date', width: 150 },
		{ field: 'payableAmount', headerName: 'Ticket Cost', width: 150 },
		{
			field: 'bookingStatus',
			headerName: 'Booking Status',
			width: 200,
			editable: true,
		},
		{
			field: 'action',
			headerName: 'Action',
			width: 300,
			editable: true,
			renderCell: (cellValues) => {
				return (
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							padding: 10,
						}}>
						<Button
							variant='contained'
							color='primary'
							style={{ marginLeft: 10 }}
							onClick={(event) => {
								console.log('first', cellValues);
								history.push({
									pathname: '/ticketdisplay',
									state: cellValues.row,
								});
							}}>
							Print
						</Button>
					</Box>
				);
			},
		},
	];
	// const handleClick = (event, cellValues) => {
	// 	console.log('id', cellValues.id);
	// };
	// const handleClickDelete = (event, cellValues) => {
	// 	console.log('id', cellValues.id);
	// 	dispatch(deletebannerDispatch(cellValues.id, loginInfo.token));
	// };
	return (
		<Box sx={{ height: '100%', width: '100%' }}>
			{bookinghistoryagent &&
			bookinghistoryagent?.result.flights?.length > 0 ? (
				<DataGrid
					rows={bookinghistoryagent?.result?.flights}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 10,
							},
						},
					}}
					pageSizeOptions={[10]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
